import { useCallback } from "react";

import useCurrentUser from "../../../../hooks/useCurrentUser";
import { GenericObject } from "../../../../types/generic.types";
import { AppResource } from "../../../../types/resource.types";
import { academyReviewsSubCollRef } from "../../../../utils/referencies";
import useNewNotification from "../../../../components/notifications/new/useNewNotification";
import useCanceledNotification from "../../../../components/notifications/new/useCanceledNotification";
import useIsAcademy from "../../../../hooks/useIsAcademy";

const academyReviewsQuery = (id: string) => academyReviewsSubCollRef(id);

// @ts-ignore
const useAcademyReviewsNotifications = (agentType: GenericObject) => {
  const { user } = useCurrentUser();
  const { isAcademy } = useIsAcademy();

  const query = useCallback((id) => academyReviewsQuery(id), []);

  const canProceed = useCallback(
    (data) => {
      return data.canceledBy.id !== user.id;
    },
    [user.id]
  );

  useNewNotification({
    query: query,
    lastSeenAtField: AppResource.reviewsLastSeenAt,
    resource: AppResource.academyReviews,
    canReceiveNotifications: isAcademy && agentType.isWeb,
  });

  useCanceledNotification({
    query: query,
    lastSeenAtField: AppResource.reviewsLastSeenAt,
    resource: AppResource.academyReviews,
    canReceiveNotifications: isAcademy && agentType.isWeb,
    canProceed,
  });
};

export default useAcademyReviewsNotifications;
